<template>
    <svg
        width="25px"
        height="25px"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M20.3258 3.69736L18.7772 3.02307C17.9029 2.64593 16.8858 2.88022 16.2629 3.60022C14.6572 5.46879 11.0858 9.00022 5.64578 11.0345C3.36578 11.7316 1.71436 13.8459 1.71436 16.3488C1.71436 19.4116 4.20007 21.8974 7.26293 21.8974C10.7144 21.8974 15.6972 18.7259 20.9486 6.7545L20.3258 3.69736Z"
            fill="url(#paint0_radial)"
        />
        <path
            d="M14.1544 12.5031C12.6801 17.9431 7.93721 19.5431 5.8915 17.7831C4.40007 16.4974 4.56007 13.3831 5.79436 10.9774C5.74293 11.0003 5.6915 11.0174 5.63436 11.0403C3.36578 11.7317 1.71436 13.846 1.71436 16.3488C1.71436 19.4117 4.20007 21.8974 7.26293 21.8974C10.7144 21.8974 15.6972 18.726 20.9486 6.75455L20.3258 3.70312C19.3372 4.34312 15.6286 7.06312 14.1544 12.5031Z"
            fill="url(#paint1_radial)"
        />
        <path
            opacity="0.5"
            d="M20.9486 6.74859L20.5829 4.9543C19.4858 4.1543 18.5315 4.01144 18.7829 6.26287C19.3258 11.1086 14.7429 16.0514 11.3315 18.5543C7.92007 21.0572 3.11436 21.0743 1.7715 15.5543C1.7315 15.8114 1.71436 16.08 1.71436 16.3486C1.71436 19.4114 4.20007 21.8972 7.26293 21.8972C10.7144 21.8972 15.6972 18.7257 20.9486 6.74859Z"
            fill="url(#paint2_radial)"
        />
        <path
            opacity="0.75"
            d="M20.3258 3.69736L18.7772 3.02307C17.9029 2.64593 16.8858 2.88022 16.2629 3.60022C14.6572 5.46879 11.0858 9.00022 5.64578 11.0345C3.36578 11.7316 1.71436 13.8459 1.71436 16.3488C1.71436 19.4116 4.20007 21.8974 7.26293 21.8974C10.7144 21.8974 15.6972 18.7259 20.9486 6.7545L20.3258 3.69736Z"
            fill="url(#paint3_radial)"
        />
        <path
            opacity="0.75"
            d="M20.3258 3.69736L18.7772 3.02307C17.9029 2.64593 16.8858 2.88022 16.2629 3.60022C14.6572 5.46879 11.0858 9.00022 5.64578 11.0345C3.36578 11.7316 1.71436 13.8459 1.71436 16.3488C1.71436 19.4116 4.20007 21.8974 7.26293 21.8974C10.7144 21.8974 15.6972 18.7259 20.9486 6.7545L20.3258 3.69736Z"
            fill="url(#paint4_radial)"
        />
        <path
            d="M22.0801 2.5145L22.2744 2.7945C22.2744 2.7945 21.8458 3.7145 20.6344 4.78878L19.543 3.4345C19.543 3.4345 20.9544 2.96592 21.4858 2.14307L22.0801 2.5145Z"
            fill="url(#paint5_linear)"
        />
        <path
            d="M21.4859 2.14307C21.4574 2.18878 21.4231 2.2345 21.3888 2.2745C21.4059 2.3545 21.4802 2.41164 21.5259 2.49164C21.6059 2.62307 21.7717 2.77735 21.6174 3.0345C21.4631 3.29164 21.3488 3.5945 20.4517 3.69164L20.7488 4.68021C21.8745 3.65164 22.2745 2.7945 22.2745 2.7945L22.0802 2.5145L21.4859 2.14307Z"
            fill="url(#paint6_linear)"
        />
        <path
            d="M20.326 3.69736L18.7774 3.02307C17.9031 2.64593 16.886 2.88022 16.2631 3.60022C15.8574 4.0745 15.326 4.65165 14.6746 5.28022C14.7831 5.34879 15.046 5.26308 15.1088 5.24022C15.806 5.0345 16.1031 5.05736 16.7031 4.9545C16.2574 5.72593 16.206 7.05736 16.1317 7.97736C16.1317 8.00593 16.1603 8.02308 16.1831 8.00593C16.7431 7.49736 18.1088 7.1145 19.5088 6.38308C19.3831 7.42308 19.6688 8.49736 19.7203 9.41736C20.1317 8.57736 20.5431 7.69165 20.9546 6.74879L20.326 3.69736Z"
            fill="#391838"
        />
        <path
            d="M20.1889 4.58315C18.6917 6.25743 19.7717 8.46886 19.4803 9.96601C19.4631 10.0517 19.5603 10.1146 19.6289 10.0632C20.2346 9.61744 21.8974 8.21743 21.7717 6.33743C21.686 5.04029 20.4631 3.01172 20.4631 3.01172L20.1889 4.58315Z"
            fill="url(#paint7_linear)"
        />
        <path
            d="M21.7773 6.33723C21.7316 5.63438 21.3488 4.71438 21.0116 4.02295L21.0059 5.27438C21.0859 5.61723 20.7659 6.68581 20.5488 6.96581C20.3316 7.24009 20.7488 7.13723 21.1488 6.35438C21.5488 5.57152 21.1031 7.48009 20.5773 7.87438C20.1773 8.17723 20.4916 8.37723 21.2573 7.51438C21.8459 6.85152 21.3145 8.13723 20.6002 8.67438C20.2402 8.94295 20.8802 8.84581 21.1659 8.46295C21.5545 7.86295 21.8288 7.14295 21.7773 6.33723Z"
            fill="url(#paint8_linear)"
        />
        <path
            d="M20.0458 8.25126C20.0458 6.99411 20.1373 6.47411 20.4458 5.98269C20.7144 5.55411 21.303 5.06269 21.3144 4.68554C21.2573 4.55412 21.2001 4.42269 21.143 4.29697C20.9544 4.15983 20.6058 4.2284 20.2287 4.38269L20.1944 4.58269C18.6916 6.26269 19.7887 8.48554 19.4858 9.98268C19.4744 10.0341 19.543 10.057 19.5658 10.017C19.743 9.72554 20.0458 9.11983 20.0458 8.25126Z"
            fill="url(#paint9_linear)"
        />
        <path
            d="M19.9832 3.84024C21.0289 3.38881 21.3032 2.9431 21.4174 2.71453C21.5317 2.49167 21.3317 2.3431 21.1774 2.5031C20.7374 2.96024 20.3889 3.05167 20.2232 3.12024C20.0574 3.20024 19.9832 3.84024 19.9832 3.84024Z"
            fill="url(#paint10_linear)"
        />
        <path
            d="M22.0801 2.5145L22.2744 2.7945C22.2744 2.7945 21.8458 3.7145 20.6344 4.78878L19.543 3.4345C19.543 3.4345 20.9544 2.96592 21.4858 2.14307L22.0801 2.5145Z"
            fill="url(#paint11_linear)"
        />
        <path
            d="M21.4802 2.14303C21.4173 2.22303 21.6916 2.3316 21.823 2.44589C21.9602 2.56017 22.2116 2.86875 22.2745 2.78875C22.3373 2.70875 22.1202 2.39446 22.023 2.29732C21.8802 2.15446 21.543 2.06303 21.4802 2.14303Z"
            fill="url(#paint12_linear)"
        />
        <path
            d="M21.4802 2.14303C21.4173 2.22303 21.6916 2.3316 21.823 2.44589C21.9602 2.56017 22.2116 2.86875 22.2745 2.78875C22.3373 2.70875 22.1202 2.39446 22.023 2.29732C21.8802 2.15446 21.543 2.06303 21.4802 2.14303Z"
            fill="url(#paint13_linear)"
        />
        <path
            d="M14.2859 5.05729C14.3202 5.09158 14.3716 5.10872 14.5316 5.08586C14.5945 5.07443 14.663 5.06301 14.7487 5.02872C15.7773 4.66872 16.4059 4.82872 17.3259 4.54301C18.1087 4.30301 18.943 3.82301 19.4573 3.70872C19.9716 3.59443 20.4059 2.97729 20.4059 2.97729C20.4059 2.97729 18.263 1.68015 16.5087 2.75443C15.4116 3.42872 14.9316 4.17158 14.7316 4.64015C14.6059 4.92015 14.2859 5.05729 14.2859 5.05729Z"
            fill="url(#paint14_linear)"
        />
        <path
            d="M19.4516 3.71448C19.9659 3.60019 20.4002 2.98305 20.4002 2.98305C20.4002 2.98305 20.0916 2.79448 19.6173 2.62305C18.1202 2.8459 17.2802 3.5259 16.8859 3.95447C16.6916 4.1659 16.4402 4.32019 16.1544 4.37733C15.1602 4.58876 14.5259 5.09162 14.5259 5.09162C14.6173 5.08019 14.6916 5.05733 14.743 5.03447C15.7716 4.69162 16.4002 4.83447 17.3202 4.54876C18.1087 4.30876 18.943 3.82876 19.4516 3.71448Z"
            fill="url(#paint15_linear)"
        />
        <path
            d="M15.9489 7.26879C15.926 7.28593 15.8975 7.26879 15.8975 7.24021C16.0917 5.57164 16.5889 4.05164 18.4689 3.09736C19.7089 2.46878 20.966 3.08021 20.966 3.08021C21.366 3.3145 21.7775 4.77736 19.9489 5.92593C18.4575 6.86879 16.3432 6.98307 15.9489 7.26879Z"
            fill="url(#paint16_linear)"
        />
        <path
            d="M20.966 3.08008C21.6802 4.45722 19.1888 6.06294 17.9831 6.30865C17.0345 6.50294 16.2574 6.97722 16.0002 7.24008C16.486 6.97722 18.5088 6.83437 19.9545 5.92579C21.7774 4.77722 21.366 3.31436 20.966 3.08008Z"
            fill="url(#paint17_linear)"
        />
        <path
            d="M21.0688 3.16605C21.0345 3.12605 21.0002 3.09747 20.966 3.08033C20.966 3.08033 20.6174 2.9089 20.1031 2.84033C18.1717 3.6289 16.9203 5.20605 16.4974 6.04605C15.9831 7.06319 16.8688 5.77748 17.2917 5.45748C17.7145 5.13748 18.3774 5.00605 18.8231 5.07462C19.2688 5.14319 18.6974 4.82319 18.1545 4.80033C17.6117 4.77748 18.7717 4.27462 19.446 4.4689C20.1202 4.6689 19.6517 4.04033 18.8402 4.09176C18.1374 4.14319 19.7945 3.41176 21.0688 3.16605Z"
            fill="url(#paint18_linear)"
        />
        <path
            d="M16.5029 2.7543C15.4858 3.37716 15.0001 4.06859 14.7715 4.53716C14.8001 4.70859 14.8686 4.76573 14.9486 4.53716C15.1201 4.05144 15.8515 3.25144 15.7601 3.57144C15.6686 3.89144 15.5943 4.53144 15.7886 4.02287C15.9829 3.5143 16.9029 2.54859 16.6458 3.17144C16.3886 3.7943 16.4172 3.97144 16.8286 3.34287C17.2401 2.7143 18.2115 2.24001 17.9201 2.64001C17.6286 3.04002 17.7486 3.1943 18.0115 2.90287C18.1658 2.73144 18.4515 2.52001 18.7715 2.40001C18.0858 2.26859 17.2572 2.29144 16.5029 2.7543Z"
            fill="url(#paint19_linear)"
        />
        <defs>
            <radialGradient
                id="paint0_radial"
                cx="0"
                cy="0"
                r="1"
                gradientUnits="userSpaceOnUse"
                gradientTransform="translate(7.55832 13.8133) rotate(-34.9263) scale(10.9724 6.13069)"
            >
                <stop stop-color="#7F226D" />
                <stop offset="0.286" stop-color="#7B2069" />
                <stop offset="0.5783" stop-color="#6F195E" />
                <stop offset="0.8727" stop-color="#5A0F4B" />
                <stop offset="1" stop-color="#4F0940" />
            </radialGradient>
            <radialGradient
                id="paint1_radial"
                cx="0"
                cy="0"
                r="1"
                gradientUnits="userSpaceOnUse"
                gradientTransform="translate(7.47597 12.3753) rotate(-34.9263) scale(10.8432 6.99386)"
            >
                <stop stop-color="#7F226D" />
                <stop offset="0.286" stop-color="#7B2069" />
                <stop offset="0.5783" stop-color="#6F195E" />
                <stop offset="0.8727" stop-color="#5A0F4B" />
                <stop offset="1" stop-color="#4F0940" />
            </radialGradient>
            <radialGradient
                id="paint2_radial"
                cx="0"
                cy="0"
                r="1"
                gradientUnits="userSpaceOnUse"
                gradientTransform="translate(4.08072 19.8982) rotate(-35.7999) scale(15.9484 5.71464)"
            >
                <stop stop-color="#4F0940" />
                <stop offset="0.247" stop-color="#4E0B3C" />
                <stop offset="0.4996" stop-color="#4A0F30" />
                <stop offset="0.7539" stop-color="#44171B" />
                <stop offset="1" stop-color="#3C2200" />
            </radialGradient>
            <radialGradient
                id="paint3_radial"
                cx="0"
                cy="0"
                r="1"
                gradientUnits="userSpaceOnUse"
                gradientTransform="translate(9.52144 11.1639) rotate(-32.0003) scale(6.78964 1.39001)"
            >
                <stop stop-color="white" stop-opacity="0.25" />
                <stop offset="1" stop-color="white" stop-opacity="0" />
            </radialGradient>
            <radialGradient
                id="paint4_radial"
                cx="0"
                cy="0"
                r="1"
                gradientUnits="userSpaceOnUse"
                gradientTransform="translate(11.7305 17.1366) rotate(-43.0721) scale(10.4428 2.13788)"
            >
                <stop stop-color="#391838" stop-opacity="0.25" />
                <stop offset="1" stop-color="#391838" stop-opacity="0" />
            </radialGradient>
            <linearGradient
                id="paint5_linear"
                x1="22.3946"
                y1="5.054"
                x2="20.0692"
                y2="2.00336"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#76AB50" />
                <stop offset="1" stop-color="#D8F88D" />
            </linearGradient>
            <linearGradient
                id="paint6_linear"
                x1="21.858"
                y1="3.96319"
                x2="20.2218"
                y2="2.61331"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#76AB50" />
                <stop offset="1" stop-color="#D8F88D" />
            </linearGradient>
            <linearGradient
                id="paint7_linear"
                x1="20.6833"
                y1="7.43549"
                x2="14.3429"
                y2="-0.807004"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#76AB50" />
                <stop offset="1" stop-color="#D8F88D" />
            </linearGradient>
            <linearGradient
                id="paint8_linear"
                x1="22.6081"
                y1="6.51207"
                x2="12.576"
                y2="6.0212"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#4B8C1C" />
                <stop offset="1" stop-color="#76AB50" />
            </linearGradient>
            <linearGradient
                id="paint9_linear"
                x1="21.296"
                y1="3.36934"
                x2="17.5693"
                y2="11.1126"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#D8F88D" />
                <stop offset="1" stop-color="#76AB50" />
            </linearGradient>
            <linearGradient
                id="paint10_linear"
                x1="21.3168"
                y1="3.6172"
                x2="20.0951"
                y2="2.54336"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#4B8C1C" />
                <stop offset="1" stop-color="#76AB50" />
            </linearGradient>
            <linearGradient
                id="paint11_linear"
                x1="22.1818"
                y1="3.26935"
                x2="19.8127"
                y2="3.22191"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#76AB50" stop-opacity="0" />
                <stop offset="1" stop-color="#D8F88D" />
            </linearGradient>
            <linearGradient
                id="paint12_linear"
                x1="21.3626"
                y1="1.79991"
                x2="22.2291"
                y2="2.47995"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#D8F88D" />
                <stop offset="1" stop-color="#76AB50" />
            </linearGradient>
            <linearGradient
                id="paint13_linear"
                x1="21.2424"
                y1="2.12551"
                x2="22.0999"
                y2="2.62868"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="white" stop-opacity="0.5" />
                <stop offset="1" stop-color="white" stop-opacity="0" />
            </linearGradient>
            <linearGradient
                id="paint14_linear"
                x1="20.0833"
                y1="5.35423"
                x2="16.1119"
                y2="1.47359"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#76AB50" />
                <stop offset="1" stop-color="#D8F88D" />
            </linearGradient>
            <linearGradient
                id="paint15_linear"
                x1="20.5549"
                y1="11.7444"
                x2="18.7295"
                y2="5.7313"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#4B8C1C" />
                <stop offset="1" stop-color="#76AB50" />
            </linearGradient>
            <linearGradient
                id="paint16_linear"
                x1="20.5549"
                y1="11.7444"
                x2="18.7295"
                y2="5.7313"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#76AB50" />
                <stop offset="1" stop-color="#D8F88D" />
            </linearGradient>
            <linearGradient
                id="paint17_linear"
                x1="20.5549"
                y1="11.7444"
                x2="18.7295"
                y2="5.7313"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#4B8C1C" />
                <stop offset="1" stop-color="#76AB50" />
            </linearGradient>
            <linearGradient
                id="paint18_linear"
                x1="23.9561"
                y1="0.77984"
                x2="14.6603"
                y2="7.25316"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#76AB50" />
                <stop offset="1" stop-color="#D8F88D" />
            </linearGradient>
            <linearGradient
                id="paint19_linear"
                x1="18.2743"
                y1="6.65261"
                x2="16.1267"
                y2="2.11208"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#76AB50" />
                <stop offset="1" stop-color="#D8F88D" />
            </linearGradient>
        </defs>
    </svg>
</template>

<script setup>
</script>
